<template>
  <div class="o-card">
    <loading v-if="isLoading"></loading>
    <no-auth v-else-if="!hasAuthorize.getById"></no-auth>
    <not-found v-else-if="!project"></not-found>
    <div v-else>
      <PageTitle
        :title="
          $t('project.copy', {
            model: project.model,
          })
        "
        :description="$t('project.copyDescription')"
      ></PageTitle>
      <ProjectForm :project="project"></ProjectForm>
    </div>
  </div>
</template>

<script>
import Loading from "../Base/Loading/Loading.vue";
import ProjectForm from "../Projects/ProjectForm.vue";
import PageTitle from "@/components/Shared/PageTitle/index.vue";
import NotFound from "../Base/NotFound.vue";
import authorize from "../Projects/authorize";

export default {
  components: { Loading, ProjectForm, NotFound, PageTitle },
  mixins: [authorize],
  data() {
    return {
      projectId: null,
      isLoading: true,
      project: null,
    };
  },
  methods: {
    async getProject() {
      this.isLoading = true;
      const response = await this.$store.dispatch("getProjectById", {
        id: this.$route.params.projectId,
      });
      if (response.message === "OK") {
        const batteries = response.data.batteryInfo;
        const evaporatorBatteryId =
          batteries.find((b) => b.type === "Evaporator") || null;
        const condenserBatteryId =
          batteries.find((b) => b.type === "Condenser") || null;
        this.project = {
          ...response.data,
          refrigerantId: response.data.refrigerantInfo,
          compressorBrandId: response.data.compressorBrandInfo,
          brandRefrigerantId: response.data.compressorBrandRefrigerantInfo,
          refrigerantModelId: response.data.compressorRefrigerantModelInfo,
          evaporatorBatteryId: evaporatorBatteryId,
          condenserBatteryId: condenserBatteryId,
          evaporatorAirflow: evaporatorBatteryId
            ? evaporatorBatteryId.airflow
            : null,
          condenserAirflow: condenserBatteryId
            ? condenserBatteryId.airflow
            : null,
          condenserCount: condenserBatteryId
            ? {
                value: condenserBatteryId.count,
                name: condenserBatteryId.count,
              }
            : null,
          compressorCount: response.data.compressorCount
            ? {
                value: response.data.compressorCount,
                name: response.data.compressorCount,
              }
            : null,
          superheat: evaporatorBatteryId ? evaporatorBatteryId.superheat : null,
          subcooling: evaporatorBatteryId
            ? evaporatorBatteryId.subcooling
            : null,
        };
      }
      this.isLoading = false;
    },
  },
  mounted() {
    this.getProject();
  },
};
</script>

<style></style>
